import * as React from "react";
import type { SVGProps } from "react";
const SvgWineGlassesToasting = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.92 5a1 1 0 0 1-1-1V2a1 1 0 1 1 2 0v2a1 1 0 0 1-1 1ZM15.35 6.41a1 1 0 0 0 1.033.066 1 1 0 0 0 .357-.316l1.15-1.64a1 1 0 0 0-.995-1.557 1 1 0 0 0-.645.407L15.1 5.01a.999.999 0 0 0 .25 1.4Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m6.388 18.008.142.002a5.43 5.43 0 0 0 2.61-.65 4.211 4.211 0 0 0 2.16-3v-.028a1.002 1.002 0 0 0 .004-.256l.156-4.806a1 1 0 0 0-.82-1l-6.9-1.21a1 1 0 0 0-1.1.71l-1.508 4.476a.997.997 0 0 0-.112.697 4.21 4.21 0 0 0 1.05 3.177 5.69 5.69 0 0 0 2.362 1.543l-.394 2.23-1.778-.323a1 1 0 0 0-.34 1.97l2.551.463c.064.026.13.045.199.057h.115l2.645.48h.18a1 1 0 0 0 .98-.77 1 1 0 0 0-.81-1.2l-1.787-.324.395-2.238ZM8.18 15.62c.038-.02.075-.04.11-.062a4.522 4.522 0 0 1-2.84-1.398 2.51 2.51 0 0 0-2.442-.73 2.24 2.24 0 0 0 .562 1.34 3.77 3.77 0 0 0 2.207 1.177 3.78 3.78 0 0 0 2.403-.327Zm.102-2.06a2.5 2.5 0 0 0 1.048-.042l.12-3.428-5.19-.91-.71 2.191a4.528 4.528 0 0 1 3.32 1.419 2.5 2.5 0 0 0 1.412.77ZM15.22 22.313a1 1 0 0 0 .65.227l.22-.01 2.658-.483.072-.007c.035-.006.07-.014.105-.024l2.675-.486a.998.998 0 0 0 .81-1.16 1 1 0 0 0-1.15-.81l-1.806.327-.389-2.2a5.69 5.69 0 0 0 2.315-1.527 4.209 4.209 0 0 0 1.055-3.12.996.996 0 0 0-.127-.791L20.84 7.77a1 1 0 0 0-1.11-.7l-6.9 1.21a1 1 0 0 0-.82 1l.16 4.94v.15a4.21 4.21 0 0 0 2.16 3 5.43 5.43 0 0 0 2.62.64l.113.002.394 2.237-1.717.311a1 1 0 0 0-.87 1.16 1 1 0 0 0 .35.593Zm2.51-6.373a3.77 3.77 0 0 0 2.175-1.165 4.54 4.54 0 0 1-3.025-.365 2.5 2.5 0 0 0-2.575.152 2.185 2.185 0 0 0 .985 1.058 3.78 3.78 0 0 0 2.44.32Zm1.598-3.11a2.5 2.5 0 0 0 .965-.387L19.21 9.15l-5.19.91.082 2.365a4.525 4.525 0 0 1 3.638.155 2.5 2.5 0 0 0 1.588.25Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M7.487 6.396a1 1 0 0 0 .463.114.93.93 0 0 0 .54-.19 1 1 0 0 0 .25-1.39L7.62 3.29a1 1 0 0 0-1.802.403 1 1 0 0 0 .162.747l1.15 1.64a1 1 0 0 0 .357.316Z"
    />
  </svg>
);
export default SvgWineGlassesToasting;
